"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceValues = exports.pluralText = exports.sortStrings = exports.getFulltextSearch = exports.toIntOrUndefined = exports.getFullAddress = exports.isNameInSearch = exports.getFullName = exports.cleanCharacter = exports.cleanNumberCharacters = exports.filterOnlyNumbers = exports.cleanCharacterByAllowSet = exports.filterOnlyCharsInSet = exports.removeExtraCharacters = exports.normalizeText = exports.COMMON_CHARS = exports.replaceJSX = void 0;
const Sort_1 = require("../Sort");
const replaceJSX = (text, find, replace) => {
    const items = text.split(find).flatMap((item) => [item, replace]);
    return items.slice(0, -1);
};
exports.replaceJSX = replaceJSX;
const abcBase = "abcdefghijklmnopqrstuvwxyz";
const abcBefore = "áäčçďéěëíňóöřšťúůüýž"; //to easly allow only alphabet character
const abcAfter = "aaccdeeeinoorstuuuyz";
const abcNumbers = "0123456789";
exports.COMMON_CHARS = abcNumbers + abcBase + abcBase.toUpperCase() + "_.-+";
const normalizeText = (text, allowNumbers = true) => {
    return (0, exports.removeExtraCharacters)(text.trim().toLowerCase(), allowNumbers);
};
exports.normalizeText = normalizeText;
const removeExtraCharacters = (text, allowNumbers = true) => {
    let ret = "";
    for (let i = 0; i < text.length; i++) {
        ret += (0, exports.cleanCharacter)(text.charAt(i));
    }
    return ret;
};
exports.removeExtraCharacters = removeExtraCharacters;
const filterOnlyCharsInSet = (text, charSet) => {
    let ret = "";
    for (let i = 0; i < text.length; i++) {
        ret += (0, exports.cleanCharacterByAllowSet)(text.charAt(i), charSet);
    }
    return ret;
};
exports.filterOnlyCharsInSet = filterOnlyCharsInSet;
const cleanCharacterByAllowSet = (char, charSet) => {
    if (charSet.indexOf(char) !== -1) {
        return char;
    }
    else {
        return "";
    }
};
exports.cleanCharacterByAllowSet = cleanCharacterByAllowSet;
const filterOnlyNumbers = (text) => {
    let ret = "";
    for (let i = 0; i < text.length; i++) {
        ret += (0, exports.cleanNumberCharacters)(text.charAt(i));
    }
    return ret;
};
exports.filterOnlyNumbers = filterOnlyNumbers;
const cleanNumberCharacters = (char) => {
    if ((abcNumbers + ",.").indexOf(char) !== -1) {
        return char;
    }
    else {
        return "";
    }
};
exports.cleanNumberCharacters = cleanNumberCharacters;
const cleanCharacter = (char, allowNumbers = true) => {
    if (allowNumbers && abcNumbers.indexOf(char) !== -1) {
        return char;
    }
    const beforeIndex = abcBefore.indexOf(char);
    if (beforeIndex !== -1) {
        return abcAfter.charAt(beforeIndex);
    }
    else {
        if (abcBase.indexOf(char) !== -1) {
            return char;
        }
        return "";
    }
};
exports.cleanCharacter = cleanCharacter;
;
const getFullName = ({ titulPred, jmeno, prijmeni, titulZa }, withDegree = true) => {
    if (withDegree)
        return [titulPred, prijmeni, jmeno, titulZa].join(" ").trim();
    return [prijmeni, jmeno].join(" ").trim();
};
exports.getFullName = getFullName;
const isNameInSearch = (name, searchTerm) => {
    return (0, exports.normalizeText)((0, exports.getFullName)(name, false)).indexOf(searchTerm) !== -1;
};
exports.isNameInSearch = isNameInSearch;
const getFullAddress = ({ ulice, obec, psc }) => {
    return `${ulice}, ${psc} ${obec}`;
};
exports.getFullAddress = getFullAddress;
const toIntOrUndefined = (value) => {
    return value ? parseInt(value) : undefined;
};
exports.toIntOrUndefined = toIntOrUndefined;
const getFulltextSearch = (searchQuery, items, getter) => {
    const norm = (0, exports.normalizeText)(searchQuery);
    if (norm === "")
        return items;
    console.log("ABC", getter(items[0]));
    return items.filter(item => getter(item).some(value => (0, exports.normalizeText)(value).includes(norm)));
};
exports.getFulltextSearch = getFulltextSearch;
const sortStrings = (a, b, increasingOrder = true) => {
    return (0, Sort_1.definedFirstSort)(a, b, (a, b) => {
        const ret = a.localeCompare(b);
        return increasingOrder ? ret : -ret;
    });
};
exports.sortStrings = sortStrings;
const pluralText = (count, one, few, many, none) => {
    if (count === 1)
        return one;
    if (count <= 4)
        return few;
    if (count < 1)
        return none ?? many;
    return many;
};
exports.pluralText = pluralText;
const replaceValues = (text, values) => {
    let ret = text;
    for (const key in values) {
        ret = ret.replaceAll(`{${key}}`, values[key].toString());
    }
    return ret;
};
exports.replaceValues = replaceValues;
